
export default {
  toggleSidebarMinified ({ commit }) {
    commit('TOGGLE_SIDEBAR_MINIFIED');
  },
  toggleSidebarMobile ({ commit }) {
    commit('TOGGLE_SIDEBAR_MOBILE');
  },
};
